// extracted by mini-css-extract-plugin
module.exports = {"basket__items":"animations_basket__items__g1oDl","fade-in-and-expand":"animations_fade-in-and-expand__y7bG_","fade-out-and-collapse":"animations_fade-out-and-collapse__Bc9nl"};